"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFullStoryAnalytics = void 0;
const ConfigContext_1 = require("../lib/ConfigContext");
const LoggerContext_1 = require("../lib/LoggerContext");
const useFullStoryAnalytics = () => {
    const { logDebug } = (0, LoggerContext_1.useLoggerContext)();
    const { ANALYTICS_ID } = (0, ConfigContext_1.useConfigContext)();
    return {
        sendEvent(name, data = {}) {
            if (window.FS && ANALYTICS_ID) {
                logDebug(`[insights useFullStoryAnalytics] ${name}`);
                window.FS('trackEvent', { name, data });
            }
        },
    };
};
exports.useFullStoryAnalytics = useFullStoryAnalytics;
//# sourceMappingURL=useFullStoryAnalytics.js.map